<div class="orbit-date-picker">
  <div class="date-input" cdkOverlayOrigin #origin="cdkOverlayOrigin">
    <input
      type="text"
      [value]="value() | date: 'mediumDate'"
      readonly
      (click)="toggleCalendar($event)" />
  </div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayPositions]="[
      { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 8 },
    ]"
    [cdkConnectedOverlayWidth]="280">
    <div class="calendar" [class.active]="isOpen()">
      <div class="calendar-header">
        <orbit-button
          [flat]="true"
          class="prev-year"
          [icon]="doubleLeftIcon"
          (click)="navigateYear(-1, $event)" />
        <orbit-button
          [flat]="true"
          [icon]="leftIcon"
          class="prev-month"
          (click)="navigateMonth(-1, $event)" />
        <div class="current-date">
          <span>{{ months()[selectedMonth()] }} {{ selectedYear() }}</span>
        </div>
        <orbit-button
          [flat]="true"
          [icon]="rightIcon"
          class="next-month"
          (click)="navigateMonth(1, $event)" />
        <orbit-button
          [flat]="true"
          [icon]="doubleRightIcon"
          class="next-year"
          (click)="navigateYear(1, $event)" />
      </div>

      <div class="weekdays">
        @for (day of weekdays(); track $index) {
          <span>{{ day }}</span>
        }
      </div>

      <div class="calendar-days">
        @for (day of daysInMonth(); track $index) {
          <button
            [class.empty]="day === 0"
            [class.today]="isToday(day)"
            [class.selected]="isSelected(day)"
            [class.disabled]="isBeforeMinDate(day)"
            [disabled]="day === 0 || isBeforeMinDate(day)"
            (click)="selectDate(day, $event)">
            @if (day !== 0) {
              {{ day }}
            }
          </button>
        }
      </div>

      <div class="calendar-footer">
        <orbit-button
          [flat]="true"
          [label]="todayLabel()"
          class="today-btn"
          (click)="goToToday($event)"></orbit-button>
        <orbit-button
          [flat]="true"
          [label]="clearLabel()"
          class="clear-btn"
          (click)="clearSelection($event)"></orbit-button>
      </div>
    </div>
  </ng-template>
</div>
